module.exports = require("angular2-useful-swiper/lib/swiper.component");